module.exports = __webpack_public_path__ + "static/media/img-02.f7443e2a.jpg";